export default __webpack_public_path__ + "static/media/bg-showcase-1.ca33ef34.jpg";